import Vue from 'vue'
import Vuex from 'vuex'
import {db} from '@/utils/firebase'
import { vuexfireMutations, firebaseAction } from 'vuexfire'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    user: {
      loggedIn: false,
      auth_data: null,
      fb_data: null,
    },
    fb_user_data: null,
    state_conversations: [],
    companies:{}
  },

  getters: {
    user(state){
      return state.user
    },
    fb_user_data(state){
      return state.fb_user_data
    },
    state_conversations(state){
      return state.state_conversations
    },
    companies(state){
      return state.companies
    }
  },

  mutations: {
    ...vuexfireMutations,

    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER_AUTH_DATA(state, data) {
      state.user.auth_data = data;
    },
    SET_USER_FB_DATA(state, data){
      state.user.fb_data = data;
      state.fb_user_data = data;
    },

  },

  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER_AUTH_DATA", {
          displayName: user.displayName,
          email: user.email
        });
        return db.ref('/users/' + user.uid).once('value').then(function(snapshot) {
          var userData = snapshot.val();
          commit("SET_USER_FB_DATA", userData)
        });
        // get user data from db
        db.ref('users/' + user.uid).once('value')
        .then(user => {
        })
      } else {
        commit("SET_USER_AUTH_DATA", null);
      }
    },

    bindConversations: firebaseAction(({ bindFirebaseRef }) => {
      // return the promise returned by `bindFirebaseRef`
      return bindFirebaseRef('state_conversations', db.ref('conversations'))
    }),

    bindCompanies: firebaseAction(({ bindFirebaseRef }) => {
      // return the promise returned by `bindFirebaseRef`
      return bindFirebaseRef('companies', db.ref('companies'))
    }),

  },

  modules: {
  }
})
